import { render, staticRenderFns } from "./TireSizeSelector.vue?vue&type=template&id=f592cbd4&"
import script from "./TireSizeSelector.controller.js?vue&type=script&lang=js&"
export * from "./TireSizeSelector.controller.js?vue&type=script&lang=js&"
import style0 from "./TireSizeSelector.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports